import Axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";

type ResponseFnType = (response: AxiosResponse<any, any>) => void;
type RequestFnType = (response: InternalAxiosRequestConfig) => void;
type ErrorResponseFnType = (error: AxiosError) => void;

const responses: ResponseFnType[] = [];
const requestes: RequestFnType[] = [];
const errorsResponses: ErrorResponseFnType[] = [];

const api = Axios.create({
  baseURL: API_URL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});
/**
 * Adds a new response interceptor to the list. The interceptor will be called
 * after the response is received, and if the response is successful, the
 * interceptor will receive the response object as an argument. If the
 * interceptor returns a boolean value, the response will be rejected if the
 * value is false, and the response will be resolved if the value is true.
 *
 * @param action The response interceptor to add.
 */
export function OnResponse(action: ResponseFnType) {
  responses.push(action);
}

/**
 * Adds a new request interceptor to the list. The interceptor will be called
 * before the request is sent, and will receive the request configuration
 * object as an argument. If the interceptor returns a boolean value, the
 * request will be rejected if the value is false, and the request will be
 * resolved if the value is true.
 *
 * @param action The request interceptor to add.
 */
export function OnRequest(action: RequestFnType) {
  requestes.push(action);
}

/**
 * Adds a new error interceptor to the list. The interceptor will be called
 * after the response is received, and if the response is an error, the
 * interceptor will receive the error object as an argument. If the
 * interceptor returns a boolean value, the error will be rejected if the
 * value is false, and the error will be resolved if the value is true.
 *
 * @param action The error interceptor to add.
 */
export function OnError(action: ErrorResponseFnType) {
  errorsResponses.push(action);
}

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  requestes.forEach((action) => action(config));
  return config;
});

api.interceptors.response.use(
  (response: AxiosResponse) => {
    responses.forEach((action) => action(response));
    return response;
  },
  (error: AxiosError) => {
    errorsResponses.forEach((action) => action(error));
    return Promise.reject(error);
  }
);

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  return config;
});

export { api };
